import { $ } from '@/libs/jquery/index'

export class RequestSettings {
  constructor() {
    this.init()
  }

  public init(): void {
    $.ajaxSetup({ cache: false })
  }
}
